import { observable } from "mobx";
import type { EntityValidationRules } from "services/validationService";

export default class PayGateTransactionsFilter {
  @observable sinceDate: Date;
  @observable untilDate: Date;
}

export const PayGateTransactionsFilterValidationRules: EntityValidationRules<PayGateTransactionsFilter> = {
  sinceDate: {
    required: true,
    isBefore: {
      condition: (entity: PayGateTransactionsFilter) => entity.untilDate,
      customMessage: "beforeUntilDate",
    },
  },
  untilDate: {
    required: true,
    isAfter: {
      condition: (entity: PayGateTransactionsFilter) => entity.sinceDate,
      customMessage: "afterSinceDate",
    },
  },
};
